// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"d7f701ca","453":"d855a71b","485":"918465a4","580":"f05e380b","593":"bc61836e","622":"24336765"}[chunkId] + ".chunk.js";
};